module.exports = __webpack_public_path__ + "static/vicious_weapon-48573b1c12cf5a6be6325147e14ab435.jpeg";